import moment from 'moment';
import { PersonCertification } from 'src/app/people/models/personCertification';

export const StringIgnoreCaseComparator = (key: string) => {
  return (a: any, b: any) => {
    return a[key] === undefined || b[key] === undefined
      ? 0
      : a[key].toUpperCase() > b[key].toUpperCase()
        ? 1
        : b[key].toUpperCase() > a[key].toUpperCase()
          ? -1
          : 0;
  };
};

export const PersonCertificationComparator = (
  a: PersonCertification,
  b: PersonCertification
): number => {
  if (!a || !b) {
    return 0;
  }

  const compareStartDate = compareDate(a.activeRange.startDate, b.activeRange.startDate);
  const compareEndDate = compareDate(a.activeRange.endDate, b.activeRange.endDate);
  const compareCreatedOnDate = compareDate(a.createdOn, b.createdOn);

  return compareStartDate === 0
    ? compareEndDate == 0
      ? compareCreatedOnDate == 0
        ? 0
        : compareCreatedOnDate
      : compareEndDate
    : compareStartDate;
};

const compareDate = (aDate, bDate): number => {
  const now = moment();
  const aDateMmt = aDate ? moment(aDate) : now;
  const bDateMmt = bDate ? moment(bDate) : now;

  return !aDate && !bDate
    ? 0
    : !aDate && bDate
      ? -1
      : aDate && !bDate
        ? 1
        : aDateMmt.isBefore(bDateMmt)
          ? 1
          : aDateMmt.isAfter(bDateMmt)
            ? -1
            : 0;
};

export const compareValues = (
  a: number | string | null | undefined,
  b: number | string | null | undefined,
  isAsc: boolean
) => {
  const aNorm = a ?? '';
  const bNorm = b ?? '';
  if (aNorm === bNorm) return 0;
  return (aNorm < bNorm ? -1 : 1) * (isAsc ? 1 : -1);
};
